import clsx from "clsx";
import React from "react";

interface ITimelineData {
  id: number;
  title: string;
  description: string;
}

const Journey: React.FC = () => {
  const timelineData: ITimelineData[] = [
    {
      id: 1,
      title: "2003: A Vision Is Born",
      description:
        "Dream Weavers was founded by Mr. Sandeep Soni and Mrs. Niti Soni as a coaching center. It initially offered courses in Personality Development, Spoken English, and preparation for exams such as IELTS, TOEFL, GMAT, GRE, SAT, as well as MBA entrance coaching and career counseling for students and professionals, helping them unlock their potential.",
    },
    {
      id: 2,
      title: "2005: Expanding Horizons",
      description:
        "Dream Weavers’ Recruitment vertical was launched with Mr. Vivek Sama joining as the Vertical Head, bringing his expertise to help organizations efficiently source top talent across diverse industries. With his leadership, the recruitment division aims to deliver tailored staffing solutions that align with organizational needs and industry trends.",
    },
    {
      id: 3,
      title: "2008: Leading in Corporate Training",
      description:
        "Dream Weavers became a leader in corporate training within the BFSI sector with the joining of Mr. Harish Ratnani. Under his leadership, the company began offering IRDA-accredited insurance training programs, helping professionals across India gain the necessary skills and certifications to excel in the insurance industry.",
    },
    {
      id: 4,
      title: "2012: Revolutionizing Learning with Technology",
      description:
        "To enhance skilling and training, Dream Weavers launched its own Learning Management System (LMS). This platform empowers colleges, universities, and corporate organizations to provide seamless and interactive digital learning experiences, ensuring efficient delivery of training programs and skills development across diverse sectors.",
    },
    {
      id: 5,
      title: "2017: Empowering India's Youth",
      description:
        "By partnering with various departments of the Government of India and state governments, Dream Weavers expanded into skill development, offering vocational courses to youth through numerous state and central government initiatives. This collaboration aims to enhance employability and empower the workforce with industry-relevant skills.",
    },
    {
      id: 6,
      title: "2020: Innovating Tourism Through Technology",
      description:
        "Leveraging technology, Dream Weavers launched a Tour Guide App designed to enhance the experience of visitors at various tourist destinations across India. This app provides real-time information, guided tours, and insights, ensuring that tourists have a rich, informative, and seamless travel experience.",
    },
    {
      id: 7,
      title: "2024: Expanded over 10+ locations",
      description:
        "From humble beginnings to becoming industry pioneers, Dream Weavers continues to innovate and lead with cutting-edge technologies, impactful skilling initiatives, and transformative training solutions. As we move forward in 2024 and beyond, we remain committed to empowering individuals, organizations, and communities with the tools and knowledge to thrive.",
    },
    {
      id: 8,
      title: "Start a new journey to be changed to … The Journey Continues",
      description: "",
    },
  ];

  const HIGHLIGHT_NAMES = [
    "Mr Sandeep Soni",
    "Neeti Soni",
    "Mr Vivek Sama",
    "Mr Harsh Ratnani",
  ];
  const highlightNames = (text: string) => {
    const regex = new RegExp(`(${HIGHLIGHT_NAMES.join("|")})`, "g");
    return text.split(regex).map((part, index) => {
      if (HIGHLIGHT_NAMES.includes(part)) {
        return (
          <strong key={`${part}-${index}`} className="font-bold">
            {part}
          </strong>
        );
      }
      return part;
    });
  };

  return (
    <div className="w-full">
      <div className="flex flex-col justify-center items-center px-5">
        <h3 className="text-xl font-medium sm:text-2xl md:text-3xl lg:text-4xl xl:text-6xl">
          Our Journey Through the Years
        </h3>
        <p className="text-sm text-center text-[#090808] pt-2 w-full xl:pt-8 xl:text-[1.5rem] max-w-3xl xl:max-w-full">
          From humble beginnings to shaping industries, see how we've grown,
          evolved, and made an impact.
        </p>
      </div>
      <div className="my-5 flex justify-center items-center w-full xl:pt-12">
        <div className="grid grid-cols-4 md:grid-cols-7 justify-center items-center w-full px-16 md:px-16 lg:px-0  ">
          <div className="col-span-3 hidden md:grid gap-20 pt-2 justify-end items-end w-full h-full">
            {timelineData.map((data, index) => (
              <div key={data.id} className="h-[7rem] md:h-[4rem]">
                {data.id % 2 === 0 ? (
                  <div className="flex flex-col gap-2 ">
                    <h3 className="lg:text-lg xl:text-[1.6rem] w-full white font-semibold text-right">
                      {data.title}
                    </h3>
                    <div className="w-full flex justify-end items-end">
                      <p className="lg:text-sm xl:text-base text-xs text-[#53648B] text-right max-w-[35rem]">
                        {highlightNames(data.description)}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            ))}
          </div>
          <div className="col-span-1 grid justify-center items-start gap-20 h-full">
            {timelineData.map((data, index) => (
              <div key={data.id} className="relative h-auto">
                <div className="flex">
                  <div
                    className={clsx(
                      `rounded-full bg-white shadow font-medium z-10`,
                      {
                        "border-4 shadow-3xl shadow-blue-500 border-blue-600 border-primary-500":
                          data.id === 1,
                        "py-4 px-[1.19rem]": data.id !== timelineData.length,
                      },
                    )}
                  >
                    {data.id === timelineData.length ? (
                      <div className="flex justify-center items-center p-[1.20rem]">
                        <img
                          src="/aboutus/hand-emoji.png"
                          alt=""
                          className="w-4"
                        />
                      </div>
                    ) : (
                      <div className="text-sm">0{data.id}</div>
                    )}
                  </div>
                </div>
                {index !== timelineData.length - 1 ? (
                  <div className="absolute left-1/2 top-full h-44 md:h-32 w-0.5 bg-neutral-300 -translate-x-1/2" />
                ) : (
                  <div className="absolute left-1/2 top-full h-0 w-0.5 bg-neutral-300 -translate-x-1/2" />
                )}
              </div>
            ))}
          </div>

          <div className="col-span-3 grid md:hidden gap-20 pt-2 justify-start items-start h-full">
            {timelineData.map((data, index) => (
              <div
                key={data.id}
                className="flex flex-col gap-2 h-[7rem] md:h-[4rem]"
              >
                <h3 className="lg:text-lg xl:text-[1.6rem] w-full text font-semibold">
                  {data.title}
                </h3>
                <div className="w-full justify-start items-start maxlg:text-sm xl:text-base -w-72">
                  <p className="text-xs text-neutral-400">
                    {highlightNames(data.description)}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="col-span-3 hidden md:grid gap-20 pt-2  justify-start w-full items-start h-full">
            {timelineData.map((data, index) => (
              <div key={data.id} className="h-[7rem] md:h-[4rem]">
                {data.id % 2 !== 0 ? (
                  <div className="flex flex-col gap-2 ">
                    <h3 className="lg:text-lg xl:text-[1.6rem] w-full text font-semibold text-left">
                      {data.title}
                    </h3>
                    <div className="w-full justify-start items-start">
                      <p className="lg:text-sm xl:text-base text-xs text-[#53648B] text-left max-w-[35rem]">
                        {highlightNames(data.description)}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Journey;
